// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3uc8i","label":"CategoryService_label__2SUxq","location":"CategoryService_location__1kqBD"};